//************************************************************
//                MATERIAL DESIGN V3 - COLORS
//************************************************************

const GREEN_10 = "#003513";
const GREEN_20 = "#005425";
const GREEN_30 = "#007033";
const GREEN_40 = "#00893d";
const GREEN_50 = "#73B281";
const GREEN_60 = "#94BF99";
const GREEN_70 = "#B2CFB3";
const GREEN_80 = "#CDDFCD";
const GREEN_90 = "#E7EFE6";
const GREEN_95 = "#F3F7F3";
const GREEN_99 = "#FCFDFC";
const GREEN_SCHAEFFLER = GREEN_40;

const FOREST_10 = "#002919";
const FOREST_20 = "#003b29";
const FOREST_30 = "#004d38";
const FOREST_40 = "#005e46";
const FOREST_50 = "#14735e";
const FOREST_60 = "#4e8c7a";
const FOREST_70 = "#7ba697";
const FOREST_80 = "#a7c3b9";
const FOREST_90 = "#d2e0db";
const FOREST_95 = "#e8f0ed";
const FOREST_99 = "#fcfdfc";

const BLUE_10 = "#001426";
const BLUE_20 = "#003513";
const BLUE_30 = "#00344B";
const BLUE_40 = "#00445F";
const BLUE_50 = "#145D78";
const BLUE_60 = "#477791";
const BLUE_70 = "#7395AC";
const BLUE_80 = "#A0B6C8";
const BLUE_90 = "#CED9E3";
const BLUE_95 = "#E6ECF2";
const BLUE_99 = "#FBFCFD";

const BLACK = "#000000";
const GREY_10 = "#343434";
const GREY_20 = "#444444";
const GREY_30 = "#555555";
const GREY_40 = "#646464";
const GREY_50 = "#828282";
const GREY_60 = "#909D9D";
const GREY_70 = "#B8B8B8";
const GREY_80 = "#D0D0D0";
const GREY_87 = "#E1E1E1";
const GREY_90 = "#E8E8E8";
const GREY_92 = "#EBEBEB";
const GREY_94 = "#F0F0F0";
const GREY_95 = "#F4F4F4";
const GREY_96 = "#F6F6F6";
const GREY_98 = "#FBFBFB";
const GREY_99 = "#FCFDFC";
export const C_WHITE = "#FFFFFF";

const RED_10 = "#500800";
const RED_30 = "#A30F0C";
const RED_40 = "#CB0B15";
const RED_80 = "#E79278";
const RED_90 = "#F8DCD1";

const YELLOW_10 = "#6A4900";
const YELLOW_40 = "#E9B300";
const YELLOW_90 = "#FDF2DC";
const YELLOW_95 = "#fffbef";

const LIME_20 = "#3C7029";
const LIME_40 = "#A1C861";
const LIME_90 = "#E2EDD0";

const TEAL_20 = "#00596E";
const TEAL_40 = "#1C98B5";
const TEAL_95 = "#f0f6fa";

//************************************************************
//                MATERIAL DESIGN V3 - SEMANTIC TOKENS
//************************************************************

export const C_PRIMARY = GREEN_SCHAEFFLER;
export const C_ON_PRIMARY = C_WHITE;
export const C_PRIMARY_CONTAINER = GREEN_90;
export const C_ON_PRIMARY_CONTAINER = GREEN_10;

export const C_SECONDARY = FOREST_40;
export const C_ON_SECONDARY = C_WHITE;
export const C_SECONDARY_CONTAINER = FOREST_90;
export const C_ON_SECONDARY_CONTAINER = FOREST_10;

export const C_TERTIARY = BLUE_40;
export const C_ON_TERTIARY = C_WHITE;
export const C_TERTIARY_CONTAINER = BLUE_90;
export const C_ON_TERTIARY_CONTAINER = BLUE_10;

export const C_ERROR = RED_40;
export const C_ON_ERROR = C_WHITE;
export const C_ERROR_CONTAINER = RED_90;
export const C_ON_ERROR_CONTAINER = RED_10;

export const C_SURFACE = GREY_95;
export const C_SURFACE_BRIGHT = GREY_98;
export const C_SURFACE_DIM = GREY_87;
export const C_SURFACE_CONTAINER = GREY_94;

export const C_ON_SURFACE = GREY_10;
export const C_ON_SURFACE_VARIANT = GREY_30;
export const C_ON_SURFACE_LOW_EMPHASIS = GREY_50; // Low emphasis text

export const C_SURFACE_CONTAINER_LOWEST = C_WHITE;
export const C_SURFACE_CONTAINER_LOW = GREY_96;
export const C_SURFACE_CONTAINER_HIGH = GREY_92;
export const C_SURFACE_CONTAINER_HIGHEST = GREY_90;
export const C_OUTLINE = GREY_50;
export const C_OUTLINE_VARIANT = GREY_80;

export const C_INVERSE_SURFACE = GREY_20;
export const C_INVERSE_ON_SURFACE = GREY_95;
export const C_INVERSE_PRIMARY = GREEN_80;

export const C_WARNING = YELLOW_40;
export const C_WARNING_CONTAINER = YELLOW_95;
export const C_ON_WARNING_CONTAINER = YELLOW_10;

export const C_SUCCESS = LIME_40;
export const C_SUCCESS_CONTAINER = LIME_90;
export const C_ON_SUCCESS_CONTAINER = LIME_20;

export const C_INFORMATION = TEAL_40;
export const C_INFORMATION_CONTAINER = TEAL_95;
export const C_ON_INFORMATION_CONTAINER = TEAL_20;

export const C_NOTIFICATION = RED_30;
export const C_ON_NOTIFICATION = C_WHITE;

export const C_SALES_CAMPAIGN = RED_40;
export const C_ON_SALES_CAMPAIGN = C_WHITE;

export const C_CHART_1 = GREEN_60;
export const C_CHART_2 = BLUE_50;
export const C_CHART_3 = RED_80;
export const C_CHART_4 = BLUE_80;
export const C_CHART_5 = BLUE_95;
export const C_CHART_6 = "#C9DEA5";
export const C_CHART_7 = GREEN_50;
export const C_CHART_8 = GREY_90;

//************************************************************
//          CUSTOM COLORS - ONE TIME COLORS WE JUST HAD TO USE
//************************************************************

export const C_IN_STOCK_AURA = "#CCE7D8";

/**
 * @deprecated - Old design token, to be phased out. In M3 hover is achieved via a state layer
 */
export const C_PRIMARY_HOVER = C_ON_PRIMARY_CONTAINER;
/**
 * @deprecated - Old design token, to be phased out. In M3 disabled is achieved in a different way.
 */
export const C_PRIMARY_DISABLED = "#99D0B1";
/**
 * @deprecated - Old design token, to be phased out. In M3 hover is achieved via a state layer
 */
export const C_SECONDARY_HOVER = "#414546";
/**
 * @deprecated - Old design token, to be phased out. In M3 disabled is achieved in a different way.
 */
export const C_SECONDARY_DISABLED = "#C1C0C0";

/**
 * @deprecated - Old design token, to be phased out.
 */
export const C_DROPDOWN_HOVER = "#ebeef0";
